/**
 * @generated SignedSource<<ccd06e47d30be46ee859fd13baef8dd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type InspectionFormMutation$variables = {
  answers: any;
  descriptions?: any | null;
  executionDate?: string | null;
  id: string;
  images?: ReadonlyArray<string> | null;
  notes: any;
  state?: InspectionStateEnum | null;
  steps: any;
};
export type InspectionFormMutation$data = {
  readonly modifyInspection: {
    readonly inspection: {
      readonly inspectionfield: {
        readonly " $fragmentSpreads": FragmentRefs<"InspectionFormOverview">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"InspectionForm">;
    } | null;
  } | null;
};
export type InspectionFormMutation = {
  response: InspectionFormMutation$data;
  variables: InspectionFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "answers"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "descriptions"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "executionDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "images"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notes"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "state"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "steps"
},
v8 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "answers",
        "variableName": "answers"
      },
      {
        "kind": "Variable",
        "name": "descriptions",
        "variableName": "descriptions"
      },
      {
        "kind": "Variable",
        "name": "executionDate",
        "variableName": "executionDate"
      },
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "images",
        "variableName": "images"
      },
      {
        "kind": "Variable",
        "name": "notes",
        "variableName": "notes"
      },
      {
        "kind": "Variable",
        "name": "state",
        "variableName": "state"
      },
      {
        "kind": "Variable",
        "name": "steps",
        "variableName": "steps"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "units",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodStart",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodEnd",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v18 = [
  (v9/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InspectionFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "UpdateInspectionMutationPayload",
        "kind": "LinkedField",
        "name": "modifyInspection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNode",
            "kind": "LinkedField",
            "name": "inspection",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InspectionForm"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "inspectionfield",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "InspectionFormOverview"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "InspectionFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "UpdateInspectionMutationPayload",
        "kind": "LinkedField",
        "name": "modifyInspection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InspectionNode",
            "kind": "LinkedField",
            "name": "inspection",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionFormNode",
                "kind": "LinkedField",
                "name": "inspectionform",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "steps",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addAdvice",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "addPhotoEndresult",
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "InspectionfieldNode",
                "kind": "LinkedField",
                "name": "inspectionfield",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedDate",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ManagementPackageSettingsNode",
                    "kind": "LinkedField",
                    "name": "managementPackageSetting",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pdfFileUrl",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FieldNode",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "geometry",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ManagementPackageSettingsNode",
                        "kind": "LinkedField",
                        "name": "managementPackageSetting",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enableWidth",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "registeredArea",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "length",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      },
                      (v12/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "orderBy",
                            "value": [
                              "-created"
                            ]
                          }
                        ],
                        "concreteType": "ReportNodeConnection",
                        "kind": "LinkedField",
                        "name": "reports",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReportNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReportNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReportTypeNode",
                                    "kind": "LinkedField",
                                    "name": "type",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "description",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "externalCode",
                                        "storageKey": null
                                      },
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "area",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "date",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FieldNode",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "reports(orderBy:[\"-created\"])"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LabelNodeConnection",
                        "kind": "LinkedField",
                        "name": "labels",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LabelNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "LabelNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "text",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectorNode",
                    "kind": "LinkedField",
                    "name": "inspector",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectNode",
                    "kind": "LinkedField",
                    "name": "managementPackageVariant",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "code",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ManagementPackageNode",
                        "kind": "LinkedField",
                        "name": "managementPackage",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberNode",
                    "kind": "LinkedField",
                    "name": "member",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "phone",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressNodeConnection",
                        "kind": "LinkedField",
                        "name": "address",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AddressNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AddressNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "street",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "houseNumber",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "zipcode",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "city",
                                    "storageKey": null
                                  },
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionNode",
                    "kind": "LinkedField",
                    "name": "latestInspection",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastModified",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionFormNode",
                        "kind": "LinkedField",
                        "name": "inspectionform",
                        "plural": false,
                        "selections": (v18/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InspectionFormNodeConnection",
                    "kind": "LinkedField",
                    "name": "inspectionforms",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InspectionFormNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "InspectionFormNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v18/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StorageObjectNodeConnection",
                "kind": "LinkedField",
                "name": "images",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StorageObjectNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StorageObjectNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "metaData",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "filename",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "downloadUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uploadedOn",
                            "storageKey": null
                          },
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rejectedDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "executionDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retryDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "retry",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "answers",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notes",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64eecdac9e9a02dfd2ae28f7e531eb44",
    "id": null,
    "metadata": {},
    "name": "InspectionFormMutation",
    "operationKind": "mutation",
    "text": "mutation InspectionFormMutation(\n  $id: ID!\n  $steps: JSONString!\n  $answers: JSONString!\n  $images: [String!]\n  $state: InspectionStateEnum\n  $notes: JSONString!\n  $descriptions: JSONString\n  $executionDate: String\n) {\n  modifyInspection(input: {id: $id, steps: $steps, answers: $answers, images: $images, state: $state, notes: $notes, descriptions: $descriptions, executionDate: $executionDate}) {\n    inspection {\n      ...InspectionForm\n      inspectionfield {\n        ...InspectionFormOverview\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment FieldDetailsAttributesFragment on FieldNode {\n  managementPackageSetting {\n    enableWidth\n    id\n  }\n  registeredArea\n  length\n  width\n  units\n}\n\nfragment FieldDetailsFragment on FieldNode {\n  id\n  ...FieldDetailsAttributesFragment\n  ...FieldDetailsReportsFragment\n  ...FieldDetailsLabelsFragment\n  ...FieldMap\n}\n\nfragment FieldDetailsLabelsFragment on FieldNode {\n  labels {\n    edges {\n      node {\n        id\n        text\n      }\n    }\n  }\n}\n\nfragment FieldDetailsReportsFragment on FieldNode {\n  reports(orderBy: [\"-created\"]) {\n    edges {\n      node {\n        id\n        type {\n          description\n          externalCode\n          id\n        }\n        units\n        area\n        date\n        field {\n          year\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment FieldMap on FieldNode {\n  geometry\n}\n\nfragment InspectionForm on InspectionNode {\n  id\n  inspectionform {\n    steps\n    addAdvice\n    addPhotoEndresult\n    id\n  }\n  inspectionfield {\n    plannedDate\n    state\n    year\n    managementPackageSetting {\n      pdfFileUrl\n      id\n    }\n    field {\n      ...FieldMap\n      ...FieldDetailsFragment\n      id\n    }\n    id\n  }\n  images {\n    edges {\n      node {\n        key\n        metaData\n        filename\n        downloadUrl\n        thumbnailUrl\n        uploadedOn\n        id\n      }\n    }\n  }\n  approvedDate\n  rejectedDate\n  executionDate\n  retryDate\n  retry\n  answers\n  notes\n  ...InspectionForm_data\n}\n\nfragment InspectionFormOverview on InspectionfieldNode {\n  id\n  externalId\n  year\n  state\n  plannedDate\n  assignedDate\n  managementPackageVariant {\n    code\n    name\n    managementPackage {\n      name\n      id\n    }\n    id\n  }\n  latestInspection {\n    id\n    state\n    lastModified\n    inspectionform {\n      id\n      year\n    }\n  }\n  inspectionforms {\n    edges {\n      node {\n        id\n        year\n      }\n    }\n  }\n  field {\n    year\n    id\n  }\n}\n\nfragment InspectionForm_data on InspectionNode {\n  id\n  inspectionfield {\n    id\n    externalId\n    plannedDate\n    inspector {\n      firstName\n      lastName\n      user {\n        firstName\n        lastName\n        id\n      }\n      id\n    }\n    managementPackageVariant {\n      name\n      code\n      managementPackage {\n        name\n        id\n      }\n      id\n    }\n    periodStart\n    periodEnd\n    member {\n      id\n      name\n      email\n      phone\n      address {\n        edges {\n          node {\n            street\n            houseNumber\n            zipcode\n            city\n            id\n          }\n        }\n      }\n    }\n    field {\n      periodStart\n      periodEnd\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bc96bad29d48bc7a3ade1c9476a80d8";

export default node;
